import React, { forwardRef, useImperativeHandle, useState } from 'react'
import { Box, Checkbox, Link, Typography, useTheme } from "@mui/material";
import { useLocation } from "react-router-dom";

// ----------------------------------------------------------------------

type Props = {
    onFinish: () => void
    onBack: () => void
}

export interface DefinitionsOralHandle {
    submit: () => void
}

export const DefinitionsOral = forwardRef<DefinitionsOralHandle, Props>(
    ({ onFinish, onBack }, ref) => {
        const [isChecked, setIsChecked] = useState(true)
        const theme = useTheme()

        const location = useLocation()
        const baseURL = window.location.href.replace(location.pathname, '')

        const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            setIsChecked(event.target.checked)
        }

        const handleContinue = () => {
            if (isChecked) {
                onFinish()
            }
        }

        useImperativeHandle(ref, () => ({ submit: handleContinue }))

        return (
            <Box>
                <Typography
                    sx={{
                        fontSize: 14,
                        color: 'text.secondary',
                        lineHeight: 1.6,
                        mb: '12px',
                    }}
                >
                    Ao formular nutracêuticos na Plataforma ProAtivos, não esqueça de agir com responsabilidade e cuidado.
                    Antes de montar sua fórmula, consulte uma farmácia especializada para confirmar se o ingrediente é
                    seguro para todos os públicos, especialmente para gestantes. Para pacientes gestantes só é permitida a
                    formulação mediante uma autorização médica.
                </Typography>
                <Typography
                    sx={{
                        fontSize: 14,
                        color: 'text.secondary',
                        lineHeight: 1.6,
                        mb: '20px',
                    }}
                >
                    A plataforma ProAtivos não se responsabiliza por formulações erradas ou quaisquer efeitos colaterais
                    resultantes do uso inadequado dos produtos formulados com ativos tópicos ou orais. Lembre-se sempre:
                    segurança em primeiro lugar!
                </Typography>

                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        p: '14px 16px',
                        border: `1px solid ${theme.palette.divider}`,
                        borderRadius: '12px',
                        backgroundColor: theme.palette.brand.surface2,
                    }}
                >
                    <Checkbox
                        onChange={handleCheckboxChange}
                        defaultChecked
                        color="secondary"
                        sx={{ p: '2px' }}
                    />
                    <Typography sx={{ fontSize: 13.5, color: 'text.primary' }}>
                        Aceito os{' '}
                        <Link
                            href={baseURL + '/use-terms'}
                            rel="noreferrer"
                            target="_blank"
                            sx={{ color: 'secondary.main', fontWeight: 600 }}
                        >
                            Termos de uso
                        </Link>
                        {' '}e{' '}
                        <Link
                            href={baseURL + '/privacy-policy'}
                            rel="noreferrer"
                            target="_blank"
                            sx={{ color: 'secondary.main', fontWeight: 600 }}
                        >
                            Política de privacidade
                        </Link>
                    </Typography>
                </Box>
            </Box>
        )
    }
)

DefinitionsOral.displayName = 'DefinitionsOral'
